import { 
  MessageCircle, Github, Heart, Mail, ExternalLink,
  Coffee, Sparkles, Star, Code2
} from 'lucide-react';
import { BOT_CONFIG } from '../config/bot';

const DEVELOPER_ID = '1124389055598170182';
const DEV_AVATAR = '/dev-avatar.png';
const DEV_USERNAME = 'Senko';

const socialLinks = [
  { icon: MessageCircle, label: 'Discord Server', href: BOT_CONFIG.supportServer, desc: 'Join our community' },
  { icon: Github, label: 'GitHub', href: 'https://github.com/Anya-Devs/Anya-Bot', desc: 'View source code' },
];

const ContactPage = () => {
  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Hero */}
        <div className="text-center mb-16">
          <p className="text-[11px] sm:text-xs uppercase tracking-[0.3em] text-primary/70 mb-4 font-medium">Contact</p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold mb-4">
            <span className="text-gradient">Get in Touch</span>
          </h1>
          <p className="text-lg text-gray-400 max-w-xl mx-auto">
            Have questions, suggestions, or just want to say hi?
          </p>
        </div>

        {/* Developer Card */}
        <div className="mb-14">
          <div className="text-[11px] font-medium text-gray-500 uppercase tracking-[0.15em] mb-4 flex items-center gap-2 px-1">
            <Code2 className="w-4 h-4 text-primary/60" />
            Developer
          </div>

          <div className="glass-card-hover p-8">
            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Avatar */}
              <div className="relative group">
                <div className="absolute inset-0 bg-primary/20 rounded-full blur-2xl opacity-0 group-hover:opacity-60 transition-opacity duration-500" />
                <img
                  src={DEV_AVATAR}
                  alt={DEV_USERNAME}
                  className="relative w-28 h-28 rounded-full ring-2 ring-white/[0.08] shadow-xl object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute bottom-1 right-1 w-5 h-5 bg-green-400 rounded-full ring-4 ring-[#06060b] animate-pulse" />
              </div>

              {/* Info */}
              <div className="flex-1 text-center md:text-left">
                <div className="flex items-center justify-center md:justify-start gap-2 mb-1.5">
                  <h3 className="text-xl font-bold text-white">{DEV_USERNAME}</h3>
                  <Sparkles className="w-4 h-4 text-yellow-400" />
                </div>
                <p className="text-gray-400 text-sm mb-4">
                  Creator of Anya Bot &bull; Full-Stack Developer &bull; Silly Lil Guy
                </p>
                <div className="flex flex-wrap justify-center md:justify-start gap-2">
                  {[
                    { icon: Star, label: 'Lead Developer', color: 'text-yellow-400' },
                    { icon: Heart, label: 'Self Lover', color: 'text-pink-400' },
                    { icon: Coffee, label: 'Powered by Fun', color: 'text-amber-400' },
                  ].map((tag) => (
                    <span key={tag.label} className="px-3 py-1 glass rounded-lg text-xs text-gray-300 flex items-center gap-1.5">
                      <tag.icon className={`w-3 h-3 ${tag.color}`} /> {tag.label}
                    </span>
                  ))}
                </div>
                <p className="mt-4 text-[11px] text-gray-600 font-mono">ID: {DEVELOPER_ID}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Links */}
        <div className="mb-14">
          <div className="text-[11px] font-medium text-gray-500 uppercase tracking-[0.15em] mb-4 flex items-center gap-2 px-1">
            <MessageCircle className="w-4 h-4 text-primary/60" />
            Connect
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {socialLinks.map((link, i) => {
              const Icon = link.icon;
              return (
                <a
                  key={i}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group glass-card-hover p-6"
                >
                  <div className="flex items-center gap-4">
                    <div className="p-3 rounded-xl bg-primary/10 text-primary group-hover:bg-primary/20 transition-colors">
                      <Icon className="w-5 h-5" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-semibold text-white text-sm group-hover:text-primary transition-colors">
                        {link.label}
                      </h3>
                      <p className="text-xs text-gray-500">{link.desc}</p>
                    </div>
                    <ExternalLink className="w-4 h-4 text-gray-600 group-hover:text-primary transition-colors shrink-0" />
                  </div>
                </a>
              );
            })}
          </div>
        </div>

        {/* Email */}
        <div className="glass-card p-8 text-center">
          <Mail className="w-8 h-8 text-primary/60 mx-auto mb-3" />
          <h3 className="text-lg font-bold text-white mb-2">Prefer Email?</h3>
          <p className="text-gray-400 text-sm mb-3">
            For business inquiries or partnerships, feel free to reach out.
          </p>
          <p className="text-primary/70 text-sm font-mono">Coming Soon</p>
        </div>

        {/* Footer note */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 text-sm italic">"Waku waku!" — Anya Forger</p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
